
/* injects from baggage-loader */

/* globals Editor, _, log, YUI */
/* jshint browser: true */
'use strict';

const moduleEditor = angular.module('editor.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller('EditorCtrl', [
  '$scope', '$rootScope', '$state', '$timeout', 'editorNavSections', 'layoutEditor', 'Widget',
  'insertBlockMenu', 'Template', 'ns', 'Site', 'editorDragPanel', 'Section', '$modal', 'State',
  'blockOverlays', 'Font', 'TimeMachine', 'Notification', '$filter', 'Parallax', 'SubscribeFormManager',
  'ImageInit', 'ButtonActionsManager', 'WidgetsSortHelper', 'EditorLibrary',
  ($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget,
   insertBlockMenu, Template, ns, Site, editorDragPanel, Section, $modal, State,
   blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, SubscribeFormManager,
   ImageInit, ButtonActionsManager, WidgetsSortHelper, EditorLibrary) => {

    let stylesCallback;

    $scope.templateIsReady = false;
    $rootScope.filter = $filter;
    $rootScope.justclick = window.justclick;
    $rootScope.isSaveDisabled = false;

    const loadStylesOfTemplate = function(sectionId) {
      if (sectionId === null || sectionId === undefined) {
        sectionId = false;
      }
      Template.getStylesheet().then(function(response) {
        angular.element('#tplStyles').text(response);
        if (stylesCallback) {
          stylesCallback();
          stylesCallback = undefined;
        }
      });
    };

    const loadStylesOfPublicSection = function() {
      Section.getPublicSectionStylesheet().then(function(response) {
        angular.element('#tplStyles').text(response);
      });
    };

    const loadStyles = function(sectionId) {
      if (sectionId === null || sectionId === undefined) {
        sectionId = false;
      }
      if ($state.includes('editor.section')) {
        loadStylesOfPublicSection();
      } else {
        loadStylesOfTemplate(sectionId);
      }
    };

    const setGradient = function(background_attributes) {
      const color_start = background_attributes.color_start;
      const color_stop = background_attributes.color_stop;
      const gradient_css = 'background-image:-moz-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-webkit-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-o-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-ms-linear-gradient(top, ' + color_start + ', ' + color_stop + ');, background-image:linear-gradient(top, ' + color_start + ', ' + color_stop + '); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=\'' + color_start + '\', endColorstr=\'' + color_stop + '\');';

      if ($('style#' + $rootScope.currentPage.id).length > 0) {
        $('style#' + $rootScope.currentPage.id).html('#tpl-wrapper:before { ' + gradient_css + ' }');
      } else {
        $('body').append('<style id=\'' + $rootScope.currentPage.id + '\'>#tpl-wrapper:before { ' + gradient_css + ' }</style>');
      }
    };

    const setBgStyles = function() {
      const bodyElement = $('#tpl-wrapper');
      const imageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;

      bodyElement.css($rootScope.currentPage.style_attributes);

      if (imageExist) {
        bodyElement.css({
          backgroundImage: 'url(\'' + $rootScope.currentPage.background_attributes.image_attributes.source_url + '\')'
        });
      }

      if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
        setGradient($rootScope.currentPage.background_attributes);
      }

      Parallax.initSection($rootScope.Y.one('#tpl-wrapper'));
    };

    const destroyGetStyles = $rootScope.$on('get:styles', function(data, sectionId, cb) {
      if (cb) {
        stylesCallback = cb;
      }

      loadStyles(sectionId);
    });

    $rootScope.checkIntBlocks = function() {
      if (Editor.mode !== 'site.page.editor') {
        return false;
      }
      $scope.intBlocksExists = false;
      Editor.getSections().forEach(function(section) {
        if (section.interactive) {
          $scope.intBlocksExists = true;
        }
      });

      $rootScope.Y.all('.str-block').each(function(block) {
        if (block.widget && block.widget.interactive) {
          $scope.intBlocksExists = true;
        }
      });
    };

    $rootScope.initWidgets = function() {
      $rootScope.Y.all('.str-section').each(function(sectionNode) {
        sectionNode.all('.str-block').each(function(block) {
          if (block.widget && block.widget.type === 'subscribe_form') {
            SubscribeFormManager.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'image') {
            ImageInit.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'link') {
            ButtonActionsManager.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'button') {
            ButtonActionsManager.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'card') {
            ButtonActionsManager.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'product') {
            block.widget.product_items_attributes.map(function(subWidget, id) {
              if (subWidget.item_type === 'button') {
                ButtonActionsManager.updateOptions(block.widget.product_items_attributes[id]);
              }
            });
          }
        });

        layoutEditor.updateSectionEtag(sectionNode.section);
      });
    };

    const addAdditionalFonts = function() {
      if (Editor.mode === 'editor.section') {
        Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
      }

      if (Editor.mode === 'site.page.editor') {
        Editor.Instrumentations.fonts = $rootScope.site.fonts_attributes;
      }

      $rootScope.$broadcast('fontNames:loaded');
    };

    const destroyFontsNames = $rootScope.$on('fontNames:loaded', function() {
      Font.connectFonts(Editor.Instrumentations.fonts);
    });

    const destroySectionFonts = $rootScope.$on('sectionFonts:loaded', function(e, fonts) {
      Font.connectFonts(fonts);
    });

    const startEditPublicSection = function() {
      if (Editor.mode === 'editor.section') {
        const layout = $rootScope.Y.one(ns.sectionClass);

        editorDragPanel._onClickEditSection({
          target: layout
        });
      }
    };

    const removeAutoPlay = function(htmlData) {
      if (!htmlData) {
        return '';
      }

      return htmlData.replace(new RegExp('autoplay=1', 'g'), '');
    };

    const preventForm = function(e) {
      return e.preventDefault();
    };

    const preventFormsSubmit = function() {
      angular.element('body').on('submit', 'form', preventForm);
    };

    const unbindPreventForm = function() {
      angular.element('body').off('submit', 'form', preventForm);
    };

    const parseHTML = function(selector, htmlString) {
      let contentSectionsHTML = '';

      const codeHTML = (
          '<div class="str-bw_code-html-overlay">' +
            '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' +
            '<div class="str-bw_code-html-overlay-text">' + ($filter('translate')('widget.code.text')) + '</div>' +
          '</div>'
      );
      const fbHTML = (
          '<div class="str-bw_code-html-overlay str-bw_code-html-overlay_fb">' +
            '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' +
            '<div class="str-bw_code-html-overlay-text">' + ($filter('translate')('widget.comments.text')) + '</div>' +
          '</div>'
      );
      const jContent = $('<div/>').html(htmlString).contents();

      jContent.find('.str-bw_code-html').html(codeHTML);
      jContent.find('.strw-fb-comments').html(fbHTML);

      if (selector !== 'section' && jContent.find(selector)[0]) {
        return jContent.find(selector)[0].outerHTML;
      }

      if (selector === 'section') {
        jContent.find('section').each(function(index, section) {
          contentSectionsHTML += section.outerHTML;
        });
        return contentSectionsHTML;
      }
    };

    const setTemplateHTML = function(htmlData) {
      if (Editor.mode === 'editor.section') {
        $('#tpl-wrapper').html(htmlData);
        return false;
      }

      htmlData = '<div>' + htmlData + '</div>';

      if (window.justclick.userSiteId) {
        const headerHTML = parseHTML('header', htmlData);
        const footerHTML = parseHTML('footer', htmlData);
        $(headerHTML).insertBefore('.str-drop-backdrop');
        $(footerHTML).insertAfter('.str-drop-backdrop');
      }

      const contentSectionsHTML = parseHTML('section', htmlData);
      $(contentSectionsHTML).insertAfter('.str-drop-backdrop');
      EditorLibrary.removeVisibilityDelay();
    };

    /**
     * Загрузка шаблона
     */
    const afterInstrumentsInitialized = function() {
      preventFormsSubmit();
      Template.loadHTML().then(function(htmlData) {
        htmlData = removeAutoPlay(htmlData);

        try {
          setTemplateHTML(htmlData);
        } catch (_error) {
          log(_error);
        }

        // Передача экземпляра Yui в класс layoutEditor
        layoutEditor.initializer($rootScope.Y);

        Template.loadJSON().then(function(data) {
          if (Editor.mode === 'editor.section' && data.for_email) {
            const newWidgetList = [];
            _.each(Editor.Instrumentations.widgetList, function(widget) {
              const ref = widget.type;
              if (ref === 'image' || ref === 'text' || ref === 'button' || ref === 'spacer' || ref === 'line') {
                newWidgetList.push(widget);
              }
            });
            Editor.Instrumentations.widgetList = newWidgetList;
          }

          $rootScope.contentSections = _.filter(data, {
            section_type: 'default'
          });

          $rootScope.sections = data;
          layoutEditor.setTemplateJSON(data);
          editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
          blockOverlays.init($rootScope.Y);
          addAdditionalFonts();

          $rootScope.toggleCommonSections();
          layoutEditor.sectionInitializers($rootScope.Y);
          $rootScope.checkIntBlocks();
          $rootScope.initWidgets();

          $timeout(function() {
            $scope.templateIsReady = true;
          }, 1000);

          $timeout(function() {
            startEditPublicSection();
          });
        });
      }, function() {
        $rootScope.alertDialog({
          title: $filter('translate')('alert.editor.error'),
          text: $filter('translate')('alert.editor.errorDescription'),
          accept_text: 'OK',
          accept: function() {
            var ref;
            if ((ref = window.justclick.currentUser.role) === 'admin' || ref === 'superadmin') {
              document.location.href = '/sites/constructor/admin/#/admin/dashboard/templates';
            } else {
              document.location.href = window.justclick.back_uri;
            }
          }
        });
      });
    };

    /**
     * currentPage
     * @param site
     * @returns {*}
     */
    const currentPage = function(site) {
      let currentPage;

      const pageId = $state.params.pageId;
      const parentPagesResult = _.filter(site.pages, {
        path: $state.params.pageId
      })[0];

      if (parentPagesResult) {
        currentPage = parentPagesResult;
      }

      site.pages.forEach(function(page) {
        page.pages.forEach(function(pageChild) {
          if (pageChild.path === pageId) {
            currentPage = pageChild;
          }
        });
      });

      return currentPage;
    };


    window.Editor = {};
    window.Editor = {
      initializer: function() {
        if (window.Editor.mode === 'site.page.mixer') {
          window.Editor.option = 'site.page.mixer';
          window.Editor.mode = 'site.page.editor';
        }

        if (window.Editor.mode === 'site.page.editor') {
          Site.get($state.params.siteId).then(function(siteData) {
            $rootScope.currentSite = siteData;
            $rootScope.currentPage = currentPage(siteData);
            $rootScope.Y.one('#tpl-wrapper').section = $rootScope.currentPage;
            setBgStyles();
            loadStyles();
          }, function() {
            $state.go('404');
          });
        }

        if (window.Editor.mode === 'editor.section') {
          loadStyles();
        }

        window.Editor.Instrumentations.initializer(afterInstrumentsInitialized);
      },
      mode: $state.current.name,
      getSections: function() {
        const sections = [];
        const domSections = $rootScope.Y.all(ns.sectionClass);
        const self = this;

        domSections.each(function(s) {
          // Установим правильную секцию при получении списка секций, если необходимо
          const previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);

          let needChangeSection = !!s.section.removed;
          if (!!previousSection && self.getSectionBackgroundImagesCount(s.section) !== self.getSectionBackgroundImagesCount(previousSection)) {
            needChangeSection = true;
          }

          if (!needChangeSection && !!previousSection && !_.isEqual(previousSection, s.section)) {
            s.section = previousSection;
          }

          sections.push(s.section);
        });

        return sections;
      },
      getEditedSections: function() {
        const sections = [];
        $rootScope.Y.all(ns.sectionClass).each(function(s) {
          if (s.edited) {
            sections.push(s.section);
          }
        });
        return sections;
      },

      getSectionBackgroundImagesCount: function(section) {
        if (typeof section.background_attributes === 'undefined') {
          return 0;
        }

        if (typeof section.background_attributes.images_attributes === 'undefined') {
          return 0;
        }

        return section.background_attributes.images_attributes.length;
      },

      destroy: function() {
        layoutEditor.destroy();
      }
    };
    Editor.Instrumentations = {
      initializer: function(cb) {
        const self = this;

        const widgetsTypesSortMap = [
          'headline_h1','headline_h2','headline_h3',
          'text', 'spacer', 'subscribe_form',
          'image', 'video', 'button',
          'list', 'timer', 'code',
          'navigation', 'link', 'review',
          'card', 'product', 'slider',
          'gallery', 'table', 'line',
          'map', 'social', 'facebook_comment'
        ];

        Widget.getAll().then(function(widgetsData) {
          self.widgetList = widgetsData.widgets;
          self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap);

          if (!!window.justclick && !!window.justclick.disableWidgets && window.justclick.disableWidgets.length > 0) {
            self.widgetList = self.widgetList.filter(function(widget) {
              return !window.justclick.disableWidgets.includes(widget.type);
            });
          }

          $timeout(function() {
            return cb();
          });
        });
      },
      defaultFonts: Font.defaults,
      widgetList: []
    };

    $rootScope.Editor = Editor;
    window.Editor = Editor;

    const destroyWidgetsFinished = $scope.$on('widgetsFinished', function(newData) {
      return insertBlockMenu.initDD();
    });

    $scope.$on('$destroy', function() {
      unbindPreventForm();
      destroyGetStyles();
      destroyWidgetsFinished();
      Editor.destroy();
      TimeMachine.destroy();
      $rootScope.widgetIsEditing = false;
      $scope.templateIsReady = false;
    });

    if (!$rootScope.Y) {
      YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', 'dd-delegate', 'event-hover', 'resize', 'resize-plugin', 'overlay', function(y) {
        $rootScope.Y = y;
        return Editor.initializer();
      });
    } else {
      Editor.initializer();
    }

    $rootScope.toggleCommonSections = function(sections) {
      sections = Editor.getSections();

      let headers = _.filter(sections, {section_type: 'header'});
      let footers = _.filter(sections, {section_type: 'footer'});

      footers = _.filter(footers, function(item) {return !item.removed;});
      headers = _.filter(headers, function(item) {return !item.removed;});

      $scope.showFooter = !footers.length;
      $scope.showHeader = !headers.length;
      if (!window.justclick.userSiteId) {
        $scope.showFooter = false;
        $scope.showHeader = false;
      }

      if (!$scope.$$phase) {
        $scope.$apply();
      }
    };

    $scope.viewSite = State.viewSite;
    $scope.saveSection = editorDragPanel.cancelSection;
    $rootScope.openEditorNavPanel = function() {
      $('.etsw-header__title').text($filter('translate')('editor.addElementButton'));
      $scope.editorNavOpen = true;
    };
    $scope.openEditorNav = function() {
      $rootScope.editorNavTab('sections');
      $rootScope.openEditorNavPanel();
    };
    $scope.panelRight = true;
    $scope.togglePanelPosition = function() {
      $scope.panelRight = !$scope.panelRight;
    };

    /**
     * Сохранение сайта
     * @param all
     */
    const publishSite = function(all) {
      const sections = Editor.getSections();

      layoutEditor.sortSections();
      Section.saveAllSectionsAndPublish(sections).then(function(sectionsData) {
        EditorLibrary.showBuildStatus(Section, $scope, null, 3000, 3000, 3);
        TimeMachine.clear();
        layoutEditor.setTemplateJSON(sectionsData);

        $timeout(function() {
          $rootScope.Y.all(ns.sectionClass).each(function(section) {
            section.edited = false;
          });

          if (layoutEditor.layout) {
            layoutEditor.layout.edited = true;
          }

          $scope.publishing = false;
          $rootScope.defaultFontSetted = false;
          Notification.success({
            message: $filter('translate')('site.saved')
          });
        }, 300);
      }, function() {
        $scope.publishing = false;
        Notification.error({
          message: $filter('translate')('site.error')
        });
      });
    };

    $rootScope.undo = function() {
      $timeout(function () {
        TimeMachine.undo();
      });
    };
    $rootScope.redo = function() {
      $timeout(function () {
        TimeMachine.redo();
      });
    };

    $rootScope.savePreview = function() {
      $scope.loading = true;
      $rootScope.Y.all('.str-section').each(function(section) {
        Section.beforeSave(section);
      });

      if ($rootScope.defaultFontSetted) {
        Site.clearFonts().then(function() {
          Site.update($rootScope.site_fonts).then(function(siteData) {
            $rootScope.site.default_font = siteData.default_font;
            $rootScope.site.h_font = siteData.h_font;
          });
        });
      }

      const sections = Editor.getSections();
      layoutEditor.sortSections();
      Section.saveAllSectionsAndPublishPreview(sections).then(function(response) {
        if (response.status && (response.data !== null && response.data !== undefined) && (response.data.preview_site_id !== null && response.data.preview_site_id !== undefined)) {
          $scope.loading = false;
          $rootScope.openPreview(response.data.preview_site_id);
        }
      }, function() {
        $scope.loading = false;
        Notification.error({
          message: $filter('translate')('site.error')
        });
      });
    };

    $rootScope.publishSite = function() {
      $timeout(function() {
        $scope.publishing = true;
        $rootScope.Y.all('.str-section').each(function(section) {
          Section.beforeSave(section);
        });

        if ($rootScope.defaultFontSetted) {
          Site.clearFonts().then(function() {
            Site.update($rootScope.site_fonts).then(function(siteData) {
              $rootScope.site.default_font = siteData.default_font;
              $rootScope.site.h_font = siteData.h_font;

              publishSite(true);
            });
          });
        } else {
          publishSite(false);
        }
      }, 300);
    };

    $scope.sectionSave = function() {
      $scope.sectionSaving = true;
      layoutEditor.publicSectionSave().then(function() {
        $scope.sectionSaving = false;
      });
    };

    $scope.exit = function() {
      $rootScope.alertDialog({
        title: $filter('translate')('alert.editor.exitTitle'),
        text: $filter('translate')('alert.editor.exitDescription'),
        accept_text: $filter('translate')('alert.confirm'),
        cancel_text: $filter('translate')('alert.cancel'),
        accept: function() {
          const ref = window.justclick.currentUser.role;
          if (ref === 'admin' || ref === 'superadmin') {
            document.location.href = '/sites/constructor/admin/#/admin/dashboard/templates';
          } else {
            document.location.href = window.justclick.back_uri;
          }
        }
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/editor.controller.js